export const DISCOUNT_TYPE_ENUM = {
  PERCENTAGE: 2,
  NOMINAL: 1
}
